import { isDevelopmentMode } from '../utils/supabase/client';

/**
 * Administrateur : rôle "admin" défini dans Supabase (app_metadata, non modifiable par l'utilisateur).
 * En démonstration, le compte admin@test.com présenté sur la page de connexion.
 * NB : ce contrôle ne sert qu'à l'affichage ; les actions sensibles sont vérifiées par le backend.
 */
export const isAdminUser = (user) =>
  user?.app_metadata?.role === 'admin' ||
  (isDevelopmentMode && user?.email === 'admin@test.com');
